import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { assignConsistencyCheckRanTemplate } from '@api/consistencyCheck';

import { TConsistencyCheckAssignTemplateDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';
import { IMessage } from '@interfaces/common/common';
import { IOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { CONSISTENCY_RAN_ASSIGN_TEMPLATE, CONSISTENCY_RAN_TABLE } from '@constants/queryKeys';

interface IUseMutateConsistencyCheckRanAssignTemplate {
	assignTemplate: UseMutateFunction<any, any, TConsistencyCheckAssignTemplateDTO, any>;
	isLoadingAssignTemplate: boolean;
}

export const useMutateConsistencyCheckRanAssignTemplate = ({
	onSuccess,
	message,
}: IOnSuccess & IMessage): IUseMutateConsistencyCheckRanAssignTemplate => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<TConsistencyCheckAssignTemplateDTO>({
		mutationKey: [CONSISTENCY_RAN_ASSIGN_TEMPLATE],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		mutationFn: assignConsistencyCheckRanTemplate,
		onSuccess: () => {
			onSuccess?.();

			dispatch(setSnackbar({
				message: message,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([CONSISTENCY_RAN_TABLE])];
		},
	});

	return {
		assignTemplate: mutate,
		isLoadingAssignTemplate: isLoading,
	};
};
